import * as ACTIONTYPE from '../constants/actiontypes'

const _default = {
  isVisible: false,
  isControlsHover: false,
  controlsVisibilityTimer: 2000,
  timerId: null,
};
export default function (state = _default, action) {
  switch (action.type) {
    case ACTIONTYPE.CONTROLS_SHOW:
      return {
        ...state,
        isVisible: true,
      }
    case ACTIONTYPE.CONTROLS_HIDE:
      return {
        ...state,
        isVisible: false,
      }
    case ACTIONTYPE.CONTROLS_TOGGLE_HOVER:
      const { isControlsHover } = action;
      return {
        ...state,
        isControlsHover
      }
    case ACTIONTYPE.SET_TIMER_ID:
      const { timerId } = action;
      return {
        ...state,
        timerId
      }
    default:
      return state;
  }

}


// WEBPACK FOOTER //
// ./src/store/reducers/ControlsReducer.js